import {
  $RolesPermissionsStates,
  $User,
  $UserAddPermissions,
  ACTIONS,
  UserPriorityEnum,
  fetchRolesPermissions,
} from "@store/user-store";
import { $WorkersDataStates, getWorkers } from "@store/workers-store";
import { ColorfulButton, TabItems } from "@components/common/common";
import { Route, Routes, useLocation } from "react-router-dom";

import { PermissionsRoles } from "@pages/permissions/permissions-roles";
import { PermissionsUsers } from "@pages/permissions/permissions-users";
// import { PermissionsMap } from "@pages/permissions/permissions-map";
import { UserDataT } from "@interfaces/user";
import { useEffect, ReactElement } from "react";
import useModal from "@modals/modal-hook";
import { useUnit } from "effector-react";
import { useSelectedCompanyQuery } from "@lib/company";

import { YMaps } from '@pbe/react-yandex-maps';

const Users = () => {
  const user = useUnit($User) as UserDataT;
  const permissions = useUnit($UserAddPermissions);
  const { isFetched } = useUnit($WorkersDataStates);

  const { company } = useSelectedCompanyQuery();

  const TAB_ITEMS: {
    label: string;
    path: string;
    exact?: boolean;
    btn?: ReactElement;
  }[] = [
    {
      label: "Пользователи",
      path: "/settings/users",
      exact: true,
      btn: permissions.hasPermission(ACTIONS.users_allowedToCreate) ? (
        <ColorfulButton
          text="Создать пользователя"
          className="colorful_action_btn_right"
          onClick={() =>
            open("CreateUserModal", {
              btnText: "Создать",
              modalData: { modalTitle: "Создать пользователя" },
            })
          }
        />
      ) : undefined,
    },
  ];
  if (
    permissions.hasRequiredLevel(UserPriorityEnum.Admin) ||
    permissions.hasPermission(ACTIONS.roles_allowedToShow)
  ) {
    TAB_ITEMS.push({
      label: "Роли",
      path: "/settings/roles",
      exact: true,
      btn: (
        <ColorfulButton
          text={"Создать роль"}
          className="colorful_action_btn_right"
          onClick={() =>
            open("CreateRoleModal", {
              modalData: {
                text: ``,
                modalTitle: "Создание роли",
                companyId: company?.id,
              },
              btnText: "Создать",
            })
          }
        />
      ),
    });
  }
  // if (
  //   permissions.hasRequiredLevel(UserPriorityEnum.Admin) ||
  //   permissions.hasRequiredLevel(UserPriorityEnum.Owner)
  // ) {
  //   TAB_ITEMS.push({
  //     label: "Карта",
  //     path: "/settings/map",
  //     exact: true,
  //   });
  // }

  const { open } = useModal();

  useEffect(() => {
    if (!isFetched) {
      getWorkers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    isFetched: isFetchedRoles,
    isLoading,
    isFetchedCompany,
  } = useUnit($RolesPermissionsStates);
  const location = useLocation();
  const IS_COMPANY_MODULE = location.pathname.includes("company");
  useEffect(() => {
    if (!company) return;

    const doesNeedToFetch =
      (!isFetchedCompany && !isLoading && IS_COMPANY_MODULE) ||
      (!isFetchedRoles && !isLoading && !IS_COMPANY_MODULE);

    if (doesNeedToFetch) {
      fetchRolesPermissions(
        IS_COMPANY_MODULE
          ? {
              exactCompany: true,
              companyId: company.id,
              priority: user.role.priority,
            }
          : { priority: user.role.priority }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company]);

  return (
    <main className="content-container">
      <div className="content-section">
        <div className="tab-section">
          <div className="tab-cont">
            <TabItems items={TAB_ITEMS} />
            <div className="tab-content-items">
              <YMaps query={{ apikey: "39326480-6e20-4e21-b43b-8abfb87aceee", suggest_apikey: "643f288c-42e8-4b85-8776-425318041d93" }}>
                <Routes>
                  {permissions.hasRequiredLevel(UserPriorityEnum.Admin) && (
                    <Route
                      path="/roles"
                      Component={PermissionsRoles}
                    />
                  )}
                  <Route
                    path={"/users"}
                    Component={PermissionsUsers}
                  />
                  {/* <Route
                    path={"/map"}
                    Component={PermissionsMap}
                  /> */}
                </Routes>
              </YMaps>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Users;
